import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table.component';
import { CustomListColumnDirective } from './directives/custom-list-column.directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PaginatorModule } from './paginator/paginator.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, NgxDatatableModule, PaginatorModule, TranslateModule],
  declarations: [TableComponent, CustomListColumnDirective],
  exports: [TableComponent, CustomListColumnDirective]
})
export class TableModule {}
